// frontend/src/pages/legal/GDPR.jsx
import React from 'react';
import LegalLayout from './LegalLayout';

const GDPR = () => (
  <LegalLayout title="GDPR &amp; Data Retention Policy" lastUpdated="22 September 2026">
    <h2>1. Data Minimisation Principle</h2>
    <p>
      In accordance with GDPR Article 5(1)(c), we adhere strictly to data minimisation. We only collect, store, and process the absolute minimum personal data necessary to authenticate user accounts, authorize operator access, and maintain application security.
    </p>

    <h2>2. Personal Data We Retain</h2>
    <p>We restrict stored personal data strictly to:</p>
    <ul>
      <li>
        <strong>Email Address:</strong> Used as your unique account identifier, for corporate domain operator authorization (e.g., matching operator access), and for essential transactional communications.
      </li>
      <li>
        <strong>Hashed Passwords:</strong> Stored using strong, one-way cryptographic hashing algorithms. Plaintext passwords are never stored or accessible by us.
      </li>
    </ul>

    <h2>3. Data Retention Schedules</h2>
    <p>
      In compliance with GDPR Article 5(1)(e) (Storage Limitation), personal data is retained according to the following schedule:
    </p>
    <ul>
      <li>
        <strong>Active Accounts:</strong> Retained for the duration of your active user account.
      </li>
      <li>
        <strong>User-Initiated Deletion:</strong> Permanently deleted from live production databases immediately upon account deletion.
      </li>
      <li>
        <strong>Inactive Accounts:</strong> Accounts inactive for 24 consecutive months are automatically scheduled for permanent deletion following a 30-day email notification.
      </li>
      <li>
        <strong>Database Backups:</strong> Encrypted system backups are retained on a rolling 30-day schedule, after which old backups are permanently overwritten.
      </li>
    </ul>

    <h2>4. Your Statutory Rights</h2>
    <p>Under the UK/EU GDPR, you hold the following rights regarding your personal data:</p>
    <ul>
      <li><strong>Right to Access (Art. 15):</strong> Request a copy of the personal data held about you.</li>
      <li><strong>Right to Rectification (Art. 16):</strong> Request correction of inaccurate account information.</li>
      <li><strong>Right to Erasure / “Right to be Forgotten” (Art. 17):</strong> Request the immediate and permanent deletion of your account credentials.</li>
      <li><strong>Right to Restrict Processing (Art. 18):</strong> Request limits on how your data is processed.</li>
    </ul>

    <h2>5. Exercise Your Data Rights</h2>
    <p>
      You may exercise your right to deletion directly via your account settings page or by submitting a request to our Data Protection Officer at{' '}
      <a href="mailto:privacy@drivenby.com">privacy@drivenby.com</a>. All manual requests are processed within 14 business days.
    </p>
  </LegalLayout>
);

export default GDPR;